module.exports = __webpack_public_path__ + "static/media/hollow_bar_shotStrip_tall.b53fc3ea.svg";